import $ from 'jquery';

(function () {
  'use strict';

  // expects a table where one of the ths in thead has a data-sort-by
  // attribute and contain multiple elements with data-sort-by attributes.
  // clicking on one of those will add an active class to it and set the sort
  // attribute of the the to the element's value. this can then be used by the
  // multi parser of the tablesorter plugin
  $.tablesorter.bindMultisortEvents = function ($table, columnIndex) {
    var $header = $table.find('thead th:eq(' + columnIndex + ')'),
      $sortHeaders = $header.find('[data-sort-by]');

    $sortHeaders.on('click', function (e) {
      e.preventDefault();
      $sortHeaders.removeClass('active');
      $(this).addClass('active');
      $header.data('sort-by', $(this).data('sort-by'));
      $table.trigger('update');
    });
  };

  // expects a data-sort-by attribute in the header th of the column
  // and will sort by the corresponding data attribute of the cell.
  // if data-sort-by is 'name' will sort by the data-name attribute of the cell
  // setting these attributes has to be done outside of the sorter.
  // whenever changin the attributes you have to trigger an 'update'
  // event on the table to clear the sorting cache
  $.tablesorter.addParser({
    id: 'multi',
    is: function () {
      return false;
    },
    format: function (s, table, cell) {
      var index = $(cell).prevAll('td').length,
        $header = $(table).find('thead th:eq(' + index + ')');
      return String($(cell).data('sort-' + $header.data('sort-by')));
    },
    type: 'text',
  });

  // expects the sort value present in the data-sort attribute of the cell
  $.tablesorter.addParser({
    id: 'data-attribute',
    is: function () {
      return false;
    },
    format: function (s, table, cell) {
      return String($(cell).data('sort'));
    },
    type: 'text',
  });
})();
